export const styles = {
  page: {
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    fontFamily: "Roboto",
    fontSize: 10,
    lineHeight: 1.5,
    padding: "20 30 20 50"
  },
  cdkLogo: {
    height: 50,
    width: 160,
    marginLeft: "70%",
    marginTop: -20
  },
  header: {
    marginTop: 5,
    display: "flex",
    flexDirection: "row"
  },
  image: {
    width: 145,
    maxHeight: 145,
    paddingLeft: 35
  },
  headerinfo: {
    width: "70%",
    textAlign: "center"
  },
  table: {
    display: "flex",
    width: "100%",
    marginRight: 20,
    marginTop: 15
  },
  tableRow: {
    flexDirection: "row",
    border: 1,
    borderBottom: "none"
  },
  lastTableRow: {
    flexDirection: "row",
    border: 1
  },
  tablecellLeft: {
    borderRight: 1,
    width: "40%",
    paddingLeft: 10,
    paddingTop: 3
  },
  tablecellRight: {
    paddingLeft: 10,
    width: "50%",
    paddingTop: 3
  },
  signatureLine: {
    marginTop: 10,
    marginBottom: 4,
    borderTop: 1
  },
  signatureSubText: {
    display: "flex",
    justifyContent: "center",
    fontWeight: "medium",
    color: "red"
  },
  headSignatureName: {
    color: "red"
  },
  bottomText: {
    display: "flex",
    flexDirection: "column"
  },
  bottomSubText: {
    paddingTop: 5,
    paddingBottom: 5
  },
  bottomSign: {
    textAlign: "right",
    paddingLeft: "55%",
    paddingTop: 25
  },
  details: {
    marginTop: 10
  },
  signature: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  },
  signatureDetails: {
    display: "flex"
  },
  employeeSignature: {
    display: "flex",
    flexDirection: "column",
    paddingTop: 35,
    width: 250
  },
  signatureName: {
    marginBottom: -10
  },
  cdkSignature: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    width: 250
  },
  signatureImage: {
    height: 40,
    width: 130
  },
  textCenter: {
    textAlign: "center"
  },
  boldItalicText: {
    fontStyle: "italic",
    fontWeight: "medium"
  },
  boldText: {
    fontWeight: "medium"
  },
  title: {
    fontWeight: "medium"
  }
};
export default styles;
